import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import { hasRelationship } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useHistory } from 'react-router-dom';
import { addQueryWithReplace } from 'Helpers/Query';
import { TransferCompleteOverride } from 'Views/Page/Content/Templates/TransferCompleteTemplate/TransferCompleteOverride';
import Content from './Content';

const useStyles = buildUseStyles('TransferCompleteStep', () => ({
  root: {},
}));

const TransferCompleteStep = ({
  className,
  resource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { loadPageContentLink } = usePageContentContext();
  const history = useHistory();

  const onNext = async () => {
    if (hasRelationship(resource, fr.relationships.redirect.name)) {
      addQueryWithReplace({ tab: 'withdrawals-transfers-tab' });
      await loadPageContentLink(resource.relationship(fr.relationships.redirect.name).link('related'));
    } else {
      // Fallthrough case - unsure where to navigate to go to dashboard
      history.push('/');
    }
  };

  const onClose = async () => {
    if (hasRelationship(resource, fr.relationships.redirectOnClose.name)) {
      await loadPageContentLink(resource.relationship(fr.relationships.redirectOnClose.name).link('related'));
    } else {
      // Fallthrough case - unsure where to navigate to go to dashboard
      history.push('/');
    }
  };

  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      layout={Content}
      LayoutProps={{
        resource,
      }}
      resource={resource}
      primaryActionLabel={resource.attr('primaryActionText')}
      metaOverrideSet={TransferCompleteOverride}
      onNext={onNext}
      hideBack
      onClose={onClose}
    />
  );
};

TransferCompleteStep.defaultProps = {
  className: '',
};

TransferCompleteStep.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default TransferCompleteStep;
